import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { handleActions } from 'redux-actions';
import { upsertResources, upsertResource, completeWithError } from 'data/qcsSyncResourceReducerHelpers';
import * as actions from 'data/entitlements/entitlementsActions';
import { DateTime } from 'luxon';
import { mkEntitlement, ENTITLEMENTS_REDUCER_KEY as KEY } from 'data/entitlements/entitlementsTypes';
import { push } from 'connected-react-router';

import { loadEntitlements, saveEntitlements, clearEntitlements } from './entitlementsUtils';

const savedStore = loadEntitlements();

const entitlementsReducer = handleActions({

  [actions.getEntitlements]:
    (state) => state.merge({ isLoading: true }),
  [actions.getEntitlementsSuccess]:
    (state, { payload }) => {
      let entitlements = payload.resources;

////////////////////////////////////////////////////////////////////////////////////////
      const entitlementsOverrideEntries = Object.entries(JSON.parse(localStorage.getItem('entitlementsOverride')) || {});
      entitlements = entitlements.map((entitlement) => {
        const entitlementOverrideEntry = entitlementsOverrideEntries.find(([key]) => key === entitlement.id);
        const valueOverride = entitlementOverrideEntry ? entitlementOverrideEntry[1] : undefined;
        return entitlementOverrideEntry ?
          entitlement.merge({
            active: Boolean(valueOverride),
            expiresOn: valueOverride ? DateTime.local().plus({ years: 1 }).toISODate() : DateTime.local().toISODate(),
            expiresAt: valueOverride ? DateTime.local().plus({ years: 1 }).toISO() : DateTime.local().toISO(),
          }) : entitlement;
      });
      entitlementsOverrideEntries
        .filter(([key]) => !entitlements.find((entitlement) => entitlement.id === key))
        .forEach(([key, value]) => entitlements.push(mkEntitlement({
          id: key,
          active: Boolean(value),
          expiresOn: value ? DateTime.local().plus({ years: 1 }).toISODate() : DateTime.local().toISODate(),
          expiresAt: value ? DateTime.local().plus({ years: 1 }).toISO() : DateTime.local().toISO(),
        })));
///////////////

      const newState = upsertResources(state, payload.set('resources', entitlements));
      saveEntitlements(newState);

      return newState;
    },
  [actions.getEntitlementsFailure]:
    (state, {payload: error, asyncDispatch}) => {
      if (error.message !== 'sanitized') {
        clearEntitlements();
        asyncDispatch(push('/fetch-subscription'));
      }
      return completeWithError(state, error);
    },

////////////////////////////////////////////////////////////////////////////////////
  [actions.setEntitlement]:
    (state, { payload }) => {
      const newState = upsertResource(state, payload);
      saveEntitlements(newState);
      return newState;
    },
///////////

}, mkQcsSyncResourceStore(savedStore));

export const ENTITLEMENTS_REDUCER_KEY = KEY;
export default entitlementsReducer;
